import { Metamodel } from '../base/model';
import { IModel, IAttribute } from '../base/annotation';
import { AzureSqlMILinkedService } from '../linkedservice/azure-sql-mi.linkedservice';
import { FileServerLinkedService } from '../linkedservice/file-server.linkedservice';
import { AzureFileStorageLinkedService } from '../linkedservice/azure-file-storage.linkedservice';
import { Named } from '../base/named';
import { shellStringResources as stringResources } from '../../Resources/ShellStringResources';

@Metamodel.model({
    name: 'packageStore',
    display: [stringResources.ModelName_PackageStore, stringResources.ModelName_PackageStores]
})
export class PackageStore extends Named {
    public static readonly MODEL: IModel;
    public static readonly STORE_NAME: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_PackageStoreName,
        association: 'STORE_NAME',
        templatable: true
    })
    public storeName: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_PackageStoreLinkedService,
        reference: true,
        type: AzureSqlMILinkedService.MODEL,
        type2: FileServerLinkedService.MODEL
    })
    public linkedService: AzureSqlMILinkedService | FileServerLinkedService | AzureFileStorageLinkedService;

    public constructor(storeName?: string, linkedService?: AzureSqlMILinkedService | FileServerLinkedService | AzureFileStorageLinkedService, name?: string, description?: string) {
        super(name, description);
        this.storeName = storeName;
        this.linkedService = linkedService;
    }

    public update(store: PackageStore): void {
        this.storeName = store.storeName;
        this.linkedService = store.linkedService;
    }

    public getServiceType(): string {
        if (this.linkedService) {
            if (this.linkedService instanceof AzureSqlMILinkedService) {
                return stringResources.AzureSQLManagedInstance_DisplayText;
            } else if (this.linkedService instanceof FileServerLinkedService) {
                return stringResources.FileSystem_DisplayText;
            } else if (this.linkedService instanceof AzureFileStorageLinkedService) {
                return stringResources.IRCreation_SSIS_PackageStore_TYPE_AzureFileStorage;
            }
        }
        return stringResources.IRCreation_SSIS_PackageStore_Type_Unsupported;
    }
}
